module.exports = __webpack_public_path__ + "img/tandem-x-visuals-FZOOxR2auVI-unsplash.f75d40f7.jpg";